import { palette } from '@guardian/source/foundations';

const tabsThemeDefault = {
  ["--background"]: palette.neutral[97],
  ["--text"]: palette.neutral[7],
  ["--border"]: palette.neutral[60],
  ["--inactiveBackground"]: palette.neutral[86]
};
const tabsDarkTheme = {
  ["--background"]: palette.neutral[20],
  ["--text"]: palette.neutral[97],
  ["--border"]: palette.neutral[60],
  ["--inactiveBackground"]: palette.neutral[7]
};
const tabThemeColour = (key) => `var(${key})`;

export { tabThemeColour, tabsDarkTheme, tabsThemeDefault };
